module.exports = __webpack_public_path__ + "media/images/icons/icon_pageType_04-f4b281d067452d2c1a4b59329da2c031.svg";